var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "go",
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.choupi) ? _c('div', {
    staticClass: "far fa-heart go__heart",
    class: {
      expand: _vm.clicked
    }
  }) : _c('div', {
    staticClass: "go__circle",
    class: {
      expand: _vm.clicked
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "go__text",
    domProps: {
      "innerHTML": _vm._s(_vm.result)
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d3d9314","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/Go.vue
// module id = 4GPP
// module chunks = 1